// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27muj","rootMobile":"styles_rootMobile__p5aN3"};